__webpack_require__.p = "/assets/turbo/6cf7444b/universalat/_next/";